import { HighlightBannerForm } from './HighlightBannerForm'
import { withHighlightBannerForm } from './withHighlightBannerForm'

const Connected = withHighlightBannerForm(HighlightBannerForm)

export { Connected as HighlightBannerForm }
